import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const ROLES_CLAIM_KEY = 'https://tzmedical.io/roles';

export default function useAuth0Roles() {
  const { isAuthenticated, user } = useAuth0();

  const roles = React.useMemo(() => {
    if (!isAuthenticated || !user) {
      return [];
    }

    const auth0Roles = user[ROLES_CLAIM_KEY];

    if (Array.isArray(auth0Roles)) {
      return auth0Roles;
    }

    if (typeof auth0Roles === 'string') {
      return [auth0Roles];
    }

    return [];
  }, [isAuthenticated, user]);

  const rolesValid = React.useMemo(() => {
    if (!isAuthenticated || !user) {
      return false;
    }

    return Object.prototype.hasOwnProperty.call(user, ROLES_CLAIM_KEY);
  }, [isAuthenticated, user]);

  return { rolesValid, roles };
}
